'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Bootstrap', 'AVRO.PricingAnalysis.PricingDepartureDatesLegendFilter'];
module.exports = angular.module('AVRO.PricingAnalysis.BenchmarkCarriers', dependencies).controller('BenchmarkCarriersController', require('./controllers/BenchmarkCarriersController')).directive('rmBenchmarkCarriers', require('./directives/BenchmarkCarriersDirective'));